import {
  useGetWorkerDetailsAtWorkplace,
  WorkerCategory,
} from "../../Professionals/api/useGetWorkerDetailsAtWorkplace";
import { useWorker } from "../../Worker/api/useWorker";

interface UseDefaultQualificationForProvisioning {
  workerId: string;
  workplaceId: string;
}

export function useDefaultQualificationForProvisioning(
  params: UseDefaultQualificationForProvisioning
) {
  const { workerId, workplaceId } = params;

  // We may want to eventually swap this out for a faster query, but this includes
  // last shift and next shift data which we need downstream (INV-2992)
  const {
    data: workerDetailsResponse,
    isLoading,
    isError,
  } = useGetWorkerDetailsAtWorkplace({
    workerIds: [workerId],
    pageSize: 1,
    facilityId: workplaceId,
    category: WorkerCategory.ALL_WORKERS,
  });
  const { shifts } = workerDetailsResponse?.workers[0] ?? {};

  const { data: worker } = useWorker(workerId);
  const { matchingFacilityQualifications, qualification: primaryQualification } = worker ?? {};

  const { lastShift, nextShift } = shifts ?? {};

  const qualification =
    nextShift?.agentReq ??
    lastShift?.agentReq ??
    matchingFacilityQualifications?.find(
      (qualification) => qualification === primaryQualification
    ) ??
    matchingFacilityQualifications?.[0];

  return { qualification, isLoading, isError };
}
